import { Link as ChakraLink } from "@chakra-ui/react"
import { forwardRef } from "react"

const Link = forwardRef((props, ref) => {
    return (
        <ChakraLink
            ref={ref}
            {...props}
        />
    )
})

export default Link